import { render, staticRenderFns } from "./BindsImage.vue?vue&type=template&id=5d2066e8&"
import script from "./BindsImage.vue?vue&type=script&lang=js&"
export * from "./BindsImage.vue?vue&type=script&lang=js&"
import style0 from "./BindsImage.vue?vue&type=style&index=0&id=5d2066e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports